import { Box } from '@material-ui/core'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Button, useNotify } from 'react-admin'
import Api from '../../../Apis/api.service'
import { useStyles } from '../styles'
import Alert from '@mui/material/Alert'
import { set } from 'react-hook-form'

const OpposantsActions = ({ id, informations, refresh }) => {
  return (
    <Box>
      <ButtonSendPv informations={informations} id={id} refresh={refresh} />
    </Box>
  )
}

const ConfirmButton = ({
  className,
  label,
  confirmLabel,
  cancelLabel,
  onClick,
  ...props
}) => {
  const [confirm, setConfirm] = useState(false)
  if (!confirm) {
    return (
      <Button
        className={className}
        onClick={(e) => setConfirm(true)}
        label={label}
        {...props}
      />
    )
  } else {
    return (
      <>
        <Button
          className={className}
          onClick={(e) => {
            e.preventDefault()
            onClick()
            setConfirm(false)
          }}
          label={confirmLabel}
          disabled={props.disabled}
        />
        <Button
          className={className}
          onClick={(e) => setConfirm(false)}
          label={cancelLabel}
          style={{ marginLeft: '16px' }}
          disabled={props.disabled}
        />
      </>
    )
  }
}

const ButtonSendPv = ({ id, informations, refresh }) => {
  const classes = useStyles()
  const notify = useNotify()
  const [loading, setLoading] = useState(false)
  let pv_unsigned = !informations?.pv_signed

  const SendPv = async () => {
    setLoading(true)
    const res = await Api.ags.sendPv(id)
    if (res.status == 204) {
      notify("Pv en cours d'envoi")
      refresh()
    } else {
      console.log(res)
    }
    setLoading(false)
  }

  if (informations?.trigger_at && informations?.areAllPvsSent) {
    return null
  }

  return (
    <>
      {!informations?.trigger_at && pv_unsigned && (
        <Alert severity="info" key="alert1">
          L'envoi du PV signé aux défaillants et opposants se fait
          automatiquement lors de la signature du PV par l'ensemble des
          signataires.
        </Alert>
      )}
      {!informations?.trigger_at && informations?.pv_signed && (
        <Alert severity="warning" key="alert2">
          Si vous avez déjà envoyé le PV via l'ancien outil, ne pas déclencher.{' '}
          <a
            target="_blank"
            href={`https://www.hello-syndic.fr/general_assemblies?utf8=%E2%9C%93&filters%5Bsearch%5D=${informations?.code}&commit=Filtrer`}
            rel="noreferrer"
          >
            Cliquez ici pour vérifier
          </a>
        </Alert>
      )}
      <ConfirmButton
        className={classes.button}
        onClick={SendPv}
        label="Envoyer le pv"
        confirmLabel="Confirmer"
        cancelLabel="Annuler"
        disabled={loading || pv_unsigned}
        style={{ marginTop: '10px' }}
      />
    </>
  )
}

export default OpposantsActions
